module.exports = __webpack_public_path__ + "img/symbol_8.79d4a752.png";